import { TrafficCameraFeature } from '../features/traffic-camera/traffic-camera.feature';
import { StandardLayerRenderer } from './standard-layer.renderer';

export class TrafficCamerasLayerRenderer extends StandardLayerRenderer {
  protected Feature = TrafficCameraFeature;
}
